// extracted by mini-css-extract-plugin
export default {"layout":"Layout_layout__bJih+","gray":"Layout_gray__KmGkx","headerContainer":"Layout_headerContainer__2M4Ry"};